import React, { useEffect, useState, useCallback } from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
  Checkbox, List, ListItem, ListItemText, ListItemSecondaryAction,
  Typography, Card, CardContent, TableRow, TableCell, TableHead, Table, TableBody,  TextField,
  Box, 
  IconButton, 
} from '@mui/material';
import axios from 'axios';
import Footer from '../components/SFooter';
import Header from '../components/Header';
import orderService from '../service/orderService';
import { useAuth } from '../context/AuthContext';
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { saveProductReview } from '../service/productReview'; 
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import Banner from '../components/Banner';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';
import BackToHome from "../components/BackToHome";



const PAGE_SIZE = 10;

//export default function OrderHistory() {
  const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
     const [viewDialogOpen, setViewDialogOpen] = useState(false);
 // const [selectedItems, setSelectedItems] = useState([]);
  const [rating, setRating] = useState(0);
  const [title, setTitle] = useState("");
  const [reviewText, setReviewText] = useState("");
    const [selectedProducts, setSelectedProducts] = useState([]); 
  const { user } = useAuth();
     const { t } = useTranslation();
    // State to track the next page number to load
    const [currentPage, setCurrentPage] = useState(0);
    // State to track loading status
    const [isLoading, setIsLoading] = useState(false);
    // State to track if there are more records to load
    const [hasMore, setHasMore] = useState(true);
    
    
    const fetchOrders = useCallback(async (pageToLoad) => {
        if (isLoading || !hasMore) return; // Prevent multiple requests or requests when no more data

        setIsLoading(true);
        console.log("pageToLoad : ", pageToLoad);
        try {
            // Service call using the updated structure (page and size)
            const response = await orderService.getUserOrder(user.userId, pageToLoad,PAGE_SIZE ); 
          
            const newOrders = response.data.content;
            const totalPages = response.data.totalPages;
          
          console.log("totla page : ", totalPages);

            setOrders(prevOrders => {
                // Append new orders to the existing list
                return [...prevOrders, ...newOrders];
            });

      //  setHasMore(false);
            console.log(" pageToLoad >= totalPages - 1  : ",  pageToLoad >= totalPages - 1);
         
          
            // Check if we have loaded all available pages
            if (pageToLoad >= totalPages - 1) {
                setHasMore(false);
            }
          console.log("hasMore : ", hasMore);
          
        } catch (error) {
            console.error("Failed to fetch orders:", error);
            // Optionally handle error state
        } finally {
            setIsLoading(false);
        }
    }, [user.userId, isLoading, hasMore]); // Include dependencies

  useEffect(() => {
    // Replace with your API endpoint
   // orderService.getUserOrder(user.userId, pageToLoad,PAGE_SIZE ).then(res => setOrders(res.data.content));
    fetchOrders(0);
  }, []);
    
    // Handler for the "Load More" button click
    const handleLoadMore = () => {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage); // Update the page number state
        fetchOrders(nextPage);    // Fetch the next page of data
    };

  const handleViewItems = (order) => {
  setSelectedOrder(order);
    setSelectedProducts([]);
    setViewDialogOpen(true);
  };

  const handleReviewClick = (order) => {
    setSelectedOrder(order);
    setSelectedProducts([]);
    setReviewDialogOpen(true);
  };



const handleItemToggle = (item) => {
  setSelectedProducts((prev) => {
    if (prev.includes(item.productId)) {
      // remove if already selected
      return prev.filter((id) => id !== item.productId);
    } else {
      // add productId
      return [...prev, item.productId];
    }
  });
};

    
    const handleStarClick = (value) => {
    setRating(value);
  };

  const handleReviewSubmit = () => {
    const review = {
      productIds: selectedProducts,
      userId: user.userId,
      rating,
      title,
      reviewText,
    };
    
   saveProductReview(review).then(() => {
      setReviewDialogOpen(false);
          setSelectedProducts([]);
    setRating(0);
    setTitle("");
    setReviewText("");
      alert('Review request submitted!');
    });
  };

  return ( 
        <>
      <Header />
    <div className="p-4 space-y-4">
      <Typography variant="h5">{t('order_history' , 'Order History')} </Typography>
      {!isLoading && orders.length === 0 ? (
    <>
     <Box
        sx={{
          textAlign: "center",
          mt: 8,
          color: "text.secondary",
        }}
      >
        <HistoryOutlinedIcon sx={{ fontSize: 80, color: "grey.500" }} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {t('no_orders_yet' , 'No orders yet')} 
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
         {t('when_you_make_a_purchase_your_order_history_will_appear_here' , ' When you make a purchase, your order history will appear here.')}
        </Typography>
        <Button variant="contained" color="primary" href="/">
           {t('browse_products' , 'Start Shopping')} 
        </Button>
      </Box>
            </>
 ) : (
   <>
      {orders
       .filter(order => order.orderStatus !== "PENDING_PAYMENT")
       .map(order => (
        <Card key={order.orderId}>
          <CardContent>
            <Typography>  {t('order' , 'Order')}  #{order.orderId}</Typography>
            <Typography> {t('status' , 'Status')}: {order.orderStatus}</Typography>
            <Typography> {t('total' , 'Total')}: ${order.grandTotal}</Typography>
            <div className="flex gap-2 mt-2">
              <Button onClick={() => handleViewItems(order)}>{t('view_items' , 'View Items')}</Button>
              <Button variant="outlined" color="error" onClick={() => handleReviewClick(order)}>{t('review' , 'Review')}</Button>
            </div>
          </CardContent>
        </Card>
      ))}
      
      {/* Display loading message while fetching */}
            {isLoading && <p>Loading more orders...</p>}

            {/* "Load More" Button: only show if we are not loading and there's more data */}
            {!isLoading && hasMore && (
            
             <Card>
              <CardContent>
                <Typography
                  variant="h6"
                  textAlign="center"
                  color="primary"
                  fontWeight="bold"
             onClick={handleLoadMore}
                >
                  + {t('load_more' , 'More Orders')}
                </Typography>
              </CardContent>
             </Card>
             
            )}

            {/* Message when all orders are loaded */}
            {!hasMore && orders.length > 0 && (
                <Typography>{t('you_have_viewed_all_your_orders' , 'You have viewed all your orders.')}</Typography>
            )}

     <BackToHome />
      
      </>
      
      )}
      
      {/* Review Dialog */}
       <Dialog open={reviewDialogOpen} onClose={() => setReviewDialogOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Select Items to Review</DialogTitle>
      <DialogContent dividers>
        {/* Items Selection */}
        <List>
          {selectedOrder?.items?.map((item) => (
            <ListItem
              key={item.orderItemId}
              button
              onClick={() => handleItemToggle(item.orderItemId)}
            >
              <ListItemText
                primary={item.productVariantName}
                secondary={`Qty: ${item.quantity}`}
              />
              <ListItemSecondaryAction>
               <Checkbox
  edge="end"
  checked={selectedProducts.includes(item.productId)}
  onChange={() => handleItemToggle(item)}
/>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>

        {/* Rating */}
        <Box sx={{ display: "flex", alignItems: "center", my: 2 }}>
          {[1, 2, 3, 4, 5].map((value) => (
            <IconButton key={value} onClick={() => handleStarClick(value)}>
              {value <= rating ? (
                <StarIcon color="primary" />
              ) : (
                <StarBorderIcon color="action" />
              )}
            </IconButton>
          ))}
        </Box>

        {/* Title */}
        <TextField
          label="Review Title"
          fullWidth
          margin="normal"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        {/* Review Text */}
        <TextField
          label="Review"
          fullWidth
          multiline
          rows={4}
          margin="normal" 
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setReviewDialogOpen(false)}>{t('cancel' , 'Cancel')}</Button>
        <Button
          variant="contained"
          onClick={handleReviewSubmit}
          disabled={selectedProducts.length === 0 || rating === 0 || !title.trim()}
        >
          {t('submit_review' , 'Submit Review')}
        </Button>
      </DialogActions>
    </Dialog>
      
       {/* View Dialog */}
      <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Select Items to View</DialogTitle>
<DialogContent>
  <Typography variant="h6" gutterBottom>
     {t('view_items' , 'Order Items')}
  </Typography>
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Product Name</TableCell>
        <TableCell align="right">Quantity</TableCell>
        <TableCell>Unit Price</TableCell>
        <TableCell align="right">Discount</TableCell>
        <TableCell align="right">Subtotal</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {selectedOrder?.items?.map(item => (
        <TableRow key={item.orderItemId}>
          <TableCell>{item.productName} - {item.productVariantName}</TableCell>
          <TableCell align="right">{item.quantity}</TableCell>
          <TableCell>{item.unitPrice}</TableCell>
          <TableCell align="right">
            {item.discountApplied ? `${item.discountApplied}` : "0"}
          </TableCell>
           <TableCell align="right">{item.subtotal}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)}> {t('cancel' , 'Cancel')}</Button>
        </DialogActions>
      </Dialog>
      
    </div>

     
       <Banner />
          <Footer />
    </>
  );
}

export default OrderHistory;